import React, { useEffect } from "react";
import PropTypes from "prop-types";
import LazyLoad from "react-lazyload";
import { connect } from "react-redux";

import * as cvActions from "../../../store/actions/curriculum";

import Card from "../../molecules/Card/Card";
import TimelineElement from "../../molecules/TimelineElement/TimelineElement";
import Spinner from "../../atoms/Spinner/Spinner";
import withErrorModal from "../../hoc/withErrorModal";

import { GiSuitcase, GiTiedScroll, GiEarthAfricaEurope } from "react-icons/gi";

const Timeline = ({ layout, curriculum, loading, onFetchCurriculum }) => {
  useEffect(() => {
    onFetchCurriculum();
  }, [onFetchCurriculum]);

  const getIconInfoByCategoryType = (cvEntryType) => {
    switch (cvEntryType) {
      case "Experience":
        return { icon: <GiSuitcase />, iconBackColor: "#fc0" };
      case "Certification":
      case "Study":
        return { icon: <GiTiedScroll />, iconBackColor: "#aae11e" };
      default:
        return { icon: <GiEarthAfricaEurope />, iconBackColor: "white" };
    }
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <div>
      {curriculum &&
        curriculum.length > 0 &&
        curriculum.map((cvEntry) => (
          <TimelineElement
            key={cvEntry.id}
            layout={layout}
            date={cvEntry.periodInCompany}
            icon={getIconInfoByCategoryType(cvEntry.type).icon}
            iconBackColor={
              getIconInfoByCategoryType(cvEntry.type).iconBackColor
            }
          >
            <LazyLoad height={500} offset={1000}>
              <Card
                title={cvEntry.position}
                subTitle={cvEntry.company}
                image={cvEntry.companyLogo}
                categories={cvEntry.categories}
              ></Card>
            </LazyLoad>
          </TimelineElement>
        ))}
    </div>
  );
};

const mapStateToProps = (state) => ({
  curriculum: state.curriculumRed.curriculum,
  loading: state.curriculumRed.loading,
});

const mapDispatchToProps = (dispatch) => ({
  onFetchCurriculum: () => dispatch(cvActions.fetchCurriculum()),
});

Timeline.propTypes = {
  layout: PropTypes.oneOf(["", "left", "right"]),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorModal(Timeline));
